import React from 'react';
import RowHeaderHelp from '../../components/RowHeaderHelp';
import UserTabs from '../../components/molecules/configuration/users/screens';

const Configurations: React.FC = () => {
  return (
    <div className="container-body no-padding">
      <RowHeaderHelp name="Configurações" />
      <UserTabs />
    </div>
  );
};

export default Configurations;
